
export default {
  name: 'BlockedEmptyState',
  props: {
    /** 无目标用户 id 时只展示「管理黑名单」 */
    showUnblock: {
      type: Boolean,
      default: true,
    },
    /** blocker：当前用户拉黑了对方；hidden：当前用户被对方拉黑 */
    variant: {
      type: String,
      default: 'blocker',
    },
  },
  computed: {
    /** 拉黑者空态才展示黑名单操作 */
    isBlockerVariant() {
      return this.variant !== 'hidden'
    },
    titleText() {
      return this.isBlockerVariant
        ? this.$t('page.PROFILE_BLOCKED_TITLE')
        : this.$t('page.PROFILE_CONTENT_HIDDEN_TITLE')
    },
    descText() {
      return this.isBlockerVariant
        ? this.$t('page.PROFILE_BLOCKED_DESC')
        : this.$t('page.PROFILE_CONTENT_HIDDEN_DESC')
    },
  },
}
